module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/fingers-crossed.png?8337dc8d2e807d564d2809d7854635bf";